/**
 * Catálogo de minijuegos de la beta (canon Adri 2026-07-11, ver
 * docs/biblia/minijuegos.md). Datos puros: nombre, mecánica y recompensas
 * base. Las escenas de minijuego leen de aquí su balance — cambiar la
 * recompensa de un minijuego debe ser editar estos datos, no su escena.
 *
 * IMPORTANTE: el `id` de cada minijuego ES la clave de su escena Phaser
 * (MissionScene comprueba `scene.manager.keys[minijuegoId]` para saber si
 * está implementado). Si cambias un id aquí, cambia la key de la escena.
 */

import type { Minigame } from './types';

export const minijuegos: Minigame[] = [
  {
    id: 'mg-21-canasta',
    nombre: 'El 21 en la canasta',
    mecanica: 'puntería: desliza hacia arriba para tirar; la longitud del gesto es la fuerza',
    controlesTouch: 'swipe hacia arriba (longitud = fuerza, desvío lateral = dirección)',
    dificultadEscalable: true,
    recompensaBase: { respeto: 3, dinero: 10 },
  },
  {
    id: 'mg-dominadas',
    nombre: 'El reto de las 100 dominadas',
    mecanica: 'ritmo: pulsa cuando el cursor pasa por la zona buena; cada acierto es una dominada',
    controlesTouch: 'tap rítmico (o barra espaciadora)',
    dificultadEscalable: true,
    // Recompensa base por completar una tanda; la escena escala según
    // el número de dominadas conseguidas (ver su cálculo proporcional).
    recompensaBase: { respeto: 2, dinero: 5 },
  },
  {
    id: 'mg-pachanga',
    nombre: 'La pachanga de fútbol casa 2v2',
    mecanica: 'timing: golpea la bola en el momento justo para pasarla por encima del tronco',
    controlesTouch: 'tap cuando la bola llega a tu lado (o barra espaciadora)',
    dificultadEscalable: true,
    recompensaBase: { respeto: 3, dinero: 10 },
  },
];

/** Devuelve el Minigame con ese id. Lanza error claro si no existe. */
export function getMinigame(id: string): Minigame {
  const m = minijuegos.find((mg) => mg.id === id);
  if (!m) {
    throw new Error(
      `[minijuegos] Minijuego con id "${id}" no encontrado. Ids: ${minijuegos.map((x) => x.id).join(', ')}`,
    );
  }
  return m;
}
